import React from 'react';

import OhsCorrespondenceExchangeRecord, {
  Exchange,
} from 'correspondence/models/OhsCorrespondenceExchangeRecord';
import { OhsFilterList } from 'dashboard/topFilter/OhsFilterModels';
import { OhsUser } from 'user/OhsUser';

import { myCommMappedStatus, MyCommStatus } from '../models/OhsMyHubModel';

export const getMyHubAccess = (user: OhsUser | undefined) => {
  const adminModuleOptionsConfig = user?.configs?.admin2?.MODULE_OPTIONS;

  const communicationEnabled =
    user?.configs?.correspondence !== null && user?.configs?.correspondence !== undefined;
  const trainingEnabled = user?.configs?.training !== null && user?.configs?.training !== undefined;

  const allowCommunication =
    adminModuleOptionsConfig?.allowActiveCorrespondenceExchangeView === true;
  const allowTraining = adminModuleOptionsConfig?.allowActiveTrainingView === true;

  const canViewCommunication = allowCommunication && communicationEnabled;
  const canViewTraining = allowTraining && trainingEnabled;

  return {
    communicationEnabled,
    trainingEnabled,
    allowCommunication,
    allowTraining,
    canViewCommunication,
    canViewTraining,
    hasMyHubPermission: canViewCommunication || canViewTraining,
  };
};

export const renderStatus = (record: any) => {
  return <span>{myCommMappedStatus[record.status as MyCommStatus]}</span>;
};

const getExchange = (record: OhsCorrespondenceExchangeRecord): Exchange => {
  return record.exchanges?.find((a: Exchange) => a.type === 'SET') as Exchange;
};

export function TemplateCell(row: any): React.ReactNode {
  return <span>{getExchange(row.original)?.prose?.title}</span>;
}

export function FormCell(row: any): React.ReactNode {
  return <span>{getExchange(row.original)?.form?.title}</span>;
}

export function isMyHubFiltersEqual<T extends object>(obj1: Partial<T>, obj2: Partial<T>) {
  return JSON.stringify(obj1) === JSON.stringify(obj2);
}

export const updateTrainingFilter = (user: OhsUser | undefined, filter: OhsFilterList) => {
  const defaultFilter = new OhsFilterList(user);
  const updatedFilter = {
    ...filter,
    hrTrainingModule: {
      ...filter.hrTrainingModule,
      sort: defaultFilter.hrTrainingModule.sort,
    },
  };

  return updatedFilter;
};
